import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Referensi from "./list-submenu/referensi";
import Finance from "./list-submenu/finance";
import Inventory from "./list-submenu/inventory";
import Pita from "./list-submenu/pita";
import ApiData from "../apis/ApiData";
import Others from "./list-submenu/others";
import Monitoring from "./list-submenu/monitoring";
import Customs from "./list-submenu/customs";
import { hasAccess, MODULES, getUserLevel, USER_LEVELS } from "../utils/rbac";
import axiosInstance from "../configs";

class Aside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navs2: [],
      hasUnreadEmails: false
    };
  }

  componentDidMount() {
    // existing fetch
    fetch(ApiData.testerUrl, { method: "GET" })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ navs2: responseJson });
      })
      .catch(console.error);

    // reinit metronic layout safely with delay to ensure DOM is ready
    setTimeout(() => {
      if (
        window.KTLayoutAside &&
        typeof window.KTLayoutAside.init === "function"
      ) {
        window.KTLayoutAside.init();
      }

      // Force scroll initialization on the aside menu wrapper
      const asideMenuWrapper = document.getElementById("kt_aside_menu_wrapper");
      if (asideMenuWrapper) {
        // Ensure overflow-y is set to auto/scroll to enable scrolling
        asideMenuWrapper.style.overflowY = "auto";
      }
    }, 300);

    // Fetch email stats
    this.fetchEmailStats();
    this.emailStatsInterval = setInterval(() => this.fetchEmailStats(), 30000);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      document.body.classList.remove("kt-aside--on");
      const overlay = document.querySelector(".kt-aside-overlay");
      if (overlay) overlay.remove();
    }
  }

  componentWillUnmount() {
    if (this.emailStatsInterval) {
      clearInterval(this.emailStatsInterval);
    }
  }

  fetchEmailStats = async () => {
    try {
      console.log("[Aside] Fetching email stats...");
      const res = await axiosInstance.get("/email/folder-stats");
      const stats = res.data.stats || {};
      const unreadCount = stats.INBOX?.unread || 0;
      console.log("[Aside] Email stats received:", stats);
      console.log("[Aside] Unread count:", unreadCount);
      console.log("[Aside] Setting hasUnreadEmails to:", unreadCount > 0);
      this.setState({ hasUnreadEmails: unreadCount > 0 });
    } catch (err) {
      console.error("[Aside] Fetch email stats error:", err);
      // Silently fail - user might not have email configured
    }
  };

  // render dinamis menu dari API
  _menuSideComponent = (menuData) => {
    return menuData.map((valData) => (
      <li key={valData.key} className="kt-menu__item">
        <a href={valData.link} className="kt-menu__link">
          <span className="kt-menu__link-icon">
            <i className="flaticon2-menu" />
          </span>
          <span className="kt-menu__link-text">{valData.name}</span>
        </a>
      </li>
    ));
  };

  // render nav static
  renderNavItem = (to, label, iconClass) => {
    const { location } = this.props;
    const isActive = location.pathname.startsWith(to);

    return (
      <li
        className={`kt-menu__item ${isActive ? "kt-menu__item--active" : ""}`}
        key={to}
      >
        <Link className="kt-menu__link" to={to}>
          <span className="kt-menu__link-icon">
            <i className={iconClass}></i>
          </span>
          <span className="kt-menu__link-text">{label}</span>
        </Link>
      </li>
    );
  };

  render() {
    return (
      <div
        className="kt-aside kt-aside--fixed kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop"
        id="kt_aside"
      >
        {/* begin:: Aside */}
        <div className="kt-aside__brand kt-grid__item" id="kt_aside_brand">
          <div className="kt-aside__brand-logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <a href="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
              <img alt="Logo" src="./assets/media/logos/alb.png" style={{ maxHeight: '40px', width: 'auto' }} />
              <span className="brand-text" style={{
                color: 'white',
                fontWeight: '700',
                fontSize: '11px',
                lineHeight: '1.2',
                letterSpacing: '0.3px',
                textTransform: 'uppercase'
              }}>
                Pasifik<br />Logistik Berikat
              </span>
            </a>
          </div>
          <div className="kt-aside__brand-tools">
            <button
              className="kt-aside__brand-aside-toggler"
              id="kt_aside_toggler"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  className="kt-svg-icon"
                >
                  <g
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                    <path
                      d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
                      id="Path-94"
                      fill="#000000"
                      fillRule="nonzero"
                      transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999)"
                    />
                    <path
                      d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
                      id="Path-94"
                      fill="#000000"
                      fillRule="nonzero"
                      opacity="0.3"
                      transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999)"
                    />
                  </g>
                </svg>
              </span>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  className="kt-svg-icon"
                >
                  <g
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
                    <path
                      d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z"
                      id="Path-94"
                      fill="#000000"
                      fillRule="nonzero"
                    />
                    <path
                      d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z"
                      id="Path-94"
                      fill="#000000"
                      fillRule="nonzero"
                      opacity="0.3"
                      transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999)"
                    />
                  </g>
                </svg>
              </span>
            </button>
          </div>
        </div>
        {/* end:: Aside */}

        {/* begin:: Aside Menu */}
        <div
          className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid"
          id="kt_aside_menu_wrapper"
        >
          <div
            id="kt_aside_menu"
            className="kt-aside-menu"
            data-ktmenu-vertical={1}
            data-ktmenu-scroll={1}
            data-ktmenu-dropdown-timeout={500}
          >
            <ul className="kt-menu__nav">
              {/* Dashboard */}
              {hasAccess(MODULES.DASHBOARD) && this.renderNavItem("/dashboard", "Dashboard", "flaticon-home")}

              {hasAccess(MODULES.PORTAL) && this.renderNavItem(
                "/portal",
                "Portal Pengguna Jasa",
                "flaticon2-laptop"
              )}

              {/* Monitoring Section */}
              {hasAccess(MODULES.MONITORING) && (
                <>
                  <li className="kt-menu__section">
                    <h4 className="kt-menu__section-text">MONITORING</h4>
                    <i className="kt-menu__section-icon flaticon-more-v2" />
                  </li>
                  <Monitoring />
                </>
              )}

              {/* Finance Section */}
              {hasAccess(MODULES.FINANCE) && (
                <>
                  <li className="kt-menu__section">
                    <h4 className="kt-menu__section-text">FINANCE</h4>
                    <i className="kt-menu__section-icon flaticon-more-v2" />
                  </li>
                  <Finance />
                </>
              )}

              {/* Inventory Section */}
              {hasAccess(MODULES.INVENTORY) && (
                <>
                  <li className="kt-menu__section">
                    <h4 className="kt-menu__section-text">INVENTORY</h4>
                    <i className="kt-menu__section-icon flaticon-more-v2" />
                  </li>
                  <Inventory />
                </>
              )}

              {/* Customs Section */}
              {hasAccess(MODULES.CUSTOMS) && (
                <>
                  <li className="kt-menu__section">
                    <h4 className="kt-menu__section-text">CUSTOMS REPORT</h4>
                    <i className="kt-menu__section-icon flaticon-more-v2" />
                  </li>
                  <Customs />
                </>
              )}

              {/* Pita Cukai Section */}
              {hasAccess(MODULES.PITA_CUKAI) && (
                <>
                  <li className="kt-menu__section">
                    <h4 className="kt-menu__section-text">PITA CUKAI</h4>
                    <i className="kt-menu__section-icon flaticon-more-v2" />
                  </li>
                  <Pita />
                </>
              )}

              {/* Others Section */}
              {hasAccess(MODULES.OTHERS) && (
                <>
                  <li className="kt-menu__section">
                    <h4 className="kt-menu__section-text">OTHERS</h4>
                    <i className="kt-menu__section-icon flaticon-more-v2" />
                  </li>
                  <Others />
                </>
              )}

              {/* Email Section */}
              {hasAccess(MODULES.EMAIL) && (
                <>
                  <li className="kt-menu__section">
                    <h4 className="kt-menu__section-text">E-MAIL</h4>
                    <i className="kt-menu__section-icon flaticon-more-v2" />
                  </li>
                  <li className="kt-menu__item">
                    <Link to="/email" className="kt-menu__link">
                      <i className="kt-menu__link-icon flaticon2-mail" />
                      <span className="kt-menu__link-text">
                        PLB Mailbox
                        {this.state.hasUnreadEmails && (
                          <span
                            style={{
                              marginLeft: "8px",
                              fontSize: "10px",
                              color: "#ff4d4f",
                              fontWeight: "bold",
                              textTransform: "uppercase"
                            }}
                          >
                            new
                          </span>
                        )}
                      </span>
                    </Link>
                  </li>
                </>
              )}

              {/* Master Data */}
              {hasAccess(MODULES.REFERENSI) && (
                <>
                  <li className="kt-menu__section">
                    <h4 className="kt-menu__section-text">MASTER DATA</h4>
                    <i className="kt-menu__section-icon flaticon-more-v2" />
                  </li>
                  <Referensi />
                </>
              )}

              {/* Data User - Separate Permission */}
              {hasAccess(MODULES.USER) && (
                <li className="kt-menu__item">
                  <Link className="kt-menu__link" to="/referensi/users">
                    <i className="kt-menu__link-icon flaticon-user"></i>
                    <span className="kt-menu__link-text">Data User</span>
                  </Link>
                </li>
              )}

              {/* Akses Role - Separate Permission */}
              {hasAccess(MODULES.ROLE_ACCESS) && (
                <li className="kt-menu__item">
                  <Link className="kt-menu__link" to="/referensi/roles">
                    <i className="kt-menu__link-icon flaticon-lock"></i>
                    <span className="kt-menu__link-text">Akses Role</span>
                  </Link>
                </li>
              )}

              {/* Menu dari API (opsional) */}
              {/* {this._menuSideComponent(this.state.navs2)} */}
            </ul>
          </div>
        </div>
        {/* end:: Aside Menu */}
      </div>
    );
  }
}

export default withRouter(Aside);
